import React, { useState } from "react";
import { Toast } from "../../CustomComponent/toast";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import performRequest from "../../api/request";
import { Form, Formik } from "formik";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema2 } from "../../Schemas/Enquiry/enquiry_schema";
import Footer from "../../Components/Footer/footer";
import CustomSelect from "../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const CreateEnquiryForm = () => {
  const [loading, setLoading] = useState(false);
  const store = useSelector((store) => store.login.user);

  const [searchParams] = useSearchParams();
  const [refresh, setRefresh] = useState(false); 
  const navigate = useNavigate();

  const id = searchParams.get("id");

  const [enquiryInfoNew, setEnquiryInfoNew] = useState(enquiryInfo);
  const [activeField, setActiveField] = useState("preferredLanguage");
  const today = new Date();
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 30);

  const productOptions = [
    { label: "Hydroponic Masterclass", value: "hydroponic_masterclass" },
    {
      label: "Practical Training",
      value: "practical_training",
    },
    { label: "Physical Site Inspection", value: "physical_site_inspection" },
    { label: "Site Inspection Kit", value: "site_inspection_kit" },
    { label: "AIF Project Report", value: "aif_project_report" },
    { label: "Project Conversion", value: "project_conversion" },
    { label: "Farm Construction", value: "farm construction" },
    { label: "Home Kit", value: "home kit" },
    { label: "General Knowledge", value: "general knowledge" },
    {
      label: "All other sales excluding CEA and Hydroponics",
      value: "other_sales",
    },
  ];

  useEffect(() => {
    if (!id) return; // 🚀 stop if id not present

    setLoading(true);

    performRequest("GET", `/enquiryWebhook/getMyoperatorJustDielDataById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setEnquiryInfoNew({
            ...enquiryInfoNew,
            ...res?.data,
            enquiryOrigin: res?.data?.origin,
            interestedIn:
              res?.data?.interestedIn || res?.data?.interested_in || [],
          });
        } else {
          Toast("error", "Error while getting PO!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const checkExistingEnquiry = async (mobileNumber, values, setFieldValue) => {
    try {
      if (mobileNumber.length !== 10) return;

      const res = await performRequest(
        "GET",
        `/enquiryWebhook/enquiryDetails/${mobileNumber}`
      );

      if (res?.status === 200 && res?.data) {
        const data = res?.data?.data;

        const setIfEmpty = (field, backendValue) => {
          if (
            (!values[field] || values[field] === "") &&
            backendValue !== undefined &&
            backendValue !== null
          ) {
            setFieldValue(field, backendValue);
          }
        };

        setIfEmpty("fullName", data.fullName);
        setIfEmpty("email", data.email);
        setIfEmpty("notes", data.notes);
        setIfEmpty("enquiryOrigin", data.origin);
        setIfEmpty(
          "enquiryRelated",
          data.enquiryRelated || data.enquiry_related_to
        );
        setIfEmpty(
          "preferredLanguage",
          data.preferredLanguage || data.preferred_language
        );
        setIfEmpty(
          "whatsappNumber",
          data.whatsapp_number || data.whatsappNumber
        );

        // Special case: array (interestedIn)
        if (
          (!values.interestedIn || values.interestedIn.length === 0) &&
          data.interestedIn
        ) {
          setFieldValue("interestedIn", data.interestedIn);
        }
        // Toast("success", "Existing enquiry data loaded");
      }
    } catch (err) {
      // If not found → do nothing (silent)
    }
  };

  const handelSubmit = (values, actions) => {
    if (
      values.phone_number === "0000000000" ||
      values.phone_number === "1111111111" ||
      values.phone_number === "2222222222" ||
      values.phone_number === "3333333333" ||
      values.phone_number === "4444444444" ||
      values.phone_number === "5555555555" ||
      values.phone_number === "6666666666" ||
      values.phone_number === "7777777777" ||
      values.phone_number === "8888888888" ||
      values.phone_number === "9999999999" ||
      values.phone_number === "1234567890" ||
      values.phone_number === "9876543210" ||
      values.phone_number === "0987654321"
    ) {
      Toast("error", "Invalid phone number");
    } else {
      let fname = values.fullName?.trim().split(" ");
      if (fname.length > 1) {
        values = {
          ...values,
          firstName: fname[0]?.trim(),
          lastName: fname[fname.length - 1]?.trim(),
        };
      } else {
        values = {
          ...values,
          firstName: fname[0]?.trim(),
        };
      }
      values = {
        ...values,
        fullName: values.fullName?.trim(),
        email: values.email?.trim(),
        mobileNumber: values.mobileNumber?.trim(),
        whatsappNumber: values.whatsappNumber?.trim(),
        notes: values.notes?.trim(),
        origin: values?.enquiryOrigin,
        generatedBy: store?.UserId,
        call_status: "completed",
        ai_call_attempts: 1,
        last_call_at: new Date(),
        summary: values.notes || "",
      };
      delete values.enquiryOrigin;
      delete values.id;

      setLoading(true);
      performRequest("POST", "/enquiryWebhook/createExhibitionEnquiry", values)
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Enquiry Created Successfully");
          } else if (res.status === 200) {
            Toast("error", res.data.message);
          } else {
            Toast("error", "Error while uploading");
          }
        })
        .catch((err) => {
          const status = err?.response?.status;
          if (status === 400) {
            Toast(
              "error",
              err.response?.data.error || "Enquiry already exists"
            );

            // ✅ navigate ONLY if id present
            if (id) {
              navigate(`/get-justDial-myOperator`);
            }
          } else {
            CustomErrorResponse(err);
          }
        })
        .finally(() => setLoading(false));
    }
  };

  const crmScripts = {
    preferredLanguage: {
      English: `Hello Sir/Madam, thank you for contacting Kryzen Biotech.
  
  My name is ${store?.Name} and I am a sales executive here.
  
  Before we begin, may I know which language is more comfortable for you — English, Hindi, or Marathi?`,

      Hindi: `नमस्कार सर / मैडम,
  कृपया Kryzen Biotech से संपर्क करने के लिए आपका धन्यवाद।
  
  मेरा नाम ${store?.Name} है और मैं यहाँ सेल्स एग्जीक्यूटिव के रूप में आपकी सहायता कर रहा हूँ।
  
  आगे बढ़ने से पहले, क्या आप बता सकते हैं कि आपके लिए कौन-सी भाषा ज्यादा सुविधाजनक रहेगी — हिंदी, अंग्रेज़ी या मराठी?`,

      Marathi: `नमस्कार सर / मॅडम,
  Kryzen Biotech शी संपर्क केल्याबद्दल धन्यवाद.
  z
  माझं नाव ${store?.Name} आहे आणि मी येथे सेल्स एक्झिक्युटिव आहे.
  
  सुरुवात करण्यापूर्वी तुम्हाला कोणती भाषा सोयीची आहे — मराठी, हिंदी की इंग्रजी?`,
    },

    fullName: {
      English: `We received your enquiry about Hydroponics / Training / Farm Setup through .
  
  Before I guide you further, may I know your first name and last name please?
  
  Thank you for sharing that.`,

      Hindi: `हमें आपका Hydroponics / Training / Farm Setup से  संबंधित enquiry प्राप्त हुआ है।
  
  आगे सही तरीके से मार्गदर्शन देने से पहले, क्या मैं आपका पहला नाम और आखिरी नाम जान सकता हूँ?
  
  धन्यवाद यह जानकारी साझा करने के लिए।`,

      Marathi: `आपली Hydroponics / Training / Farm Setup] संबंधी enquiry आम्हाला  वरून मिळाली आहे.

आपल्याला पुढे योग्य मार्गदर्शन करण्यापूर्वी, कृपया आपले पहिले नाव आणि आडनाव सांगाल का?

(CRM मध्ये माहिती भरा)

धन्यवाद [Name], ही माहिती दिल्याबद्दल.`,
    },

    last_name: {
      English: `We received your enquiry about Hydroponics / Training / Farm Setup through .
    
    Before I guide you further, may I know your first name and last name please?
    
    Thank you for sharing that.`,

      Hindi: `हमें आपका Hydroponics / Training / Farm Setup से संबंधित enquiry प्राप्त हुआ है।
    
    आगे सही तरीके से मार्गदर्शन देने से पहले, क्या मैं आपका पहला नाम और आखिरी नाम जान सकता हूँ?
    
    धन्यवाद यह जानकारी साझा करने के लिए।`,

      Marathi: `आपली Hydroponics / Training / Farm Setup संबंधी enquiry आम्हाला  वरून मिळाली आहे.
  
  आपल्याला पुढे योग्य मार्गदर्शन करण्यापूर्वी, कृपया आपले पहिले नाव आणि आडनाव सांगाल का?
  
  (CRM मध्ये माहिती भरा)
  
  धन्यवाद  ही माहिती दिल्याबद्दल.`,
    },

    email: {
      English: `I can send you details via email, kindly help me with your email id.`,

      Hindi: `मैं आपको पूरी जानकारी ईमेल के माध्यम से भेज सकता हूँ।
कृपया अपना ईमेल आईडी शेयर कर दीजिए, ताकि मैं आपको सभी details भेज सकूँ।`,

      Marathi: `मी आपल्याला सर्व माहिती ईमेलवर पाठवू शकतो.
कृपया आपला ईमेल आयडी सांगाल का, जेणेकरून मी आपल्याला सर्व details पाठवू शकेन.`,
    },

    enquiryRelated: {
      English: `Understand the intent of client and select drop down option.`,

      Hindi: `ग्राहक के उत्तर के अनुसार CRM में सही विकल्प चुनें।`,
      Marathi: `ग्राहकाच्या उत्तरानुसार CRM मध्ये योग्य पर्याय निवडा`,
    },

    prior_knowledge_of_farming: {
      English: `To guide you properly, I would like to ask a quick question.
  
  Do you currently have any experience in farming or agriculture?`,

      Hindi: `आपको सही तरीके से मार्गदर्शन देने के लिए मैं आपसे कुछ छोटे-छोटे सवाल पूछना चाहूँगा।

सबसे पहले, क्या आपका फार्मिंग या एग्रीकल्चर में पहले से कोई अनुभव या बैकग्राउंड है?`,
      Marathi: `आपल्याला योग्य मार्गदर्शन देण्यासाठी मी काही छोटे प्रश्न विचारू इच्छितो.

सर्वप्रथम, आपल्याला शेती किंवा कृषी क्षेत्राचा आधी काही अनुभव किंवा पार्श्वभूमी आहे का?`,
    },

    interestedIn: {
      English: `What would you mainly like to explore today?
  
  • Learning hydroponics
  • Practical training
  • Setting up a hydroponic farm
  • Just exploring options`,

      Hindi: `आज आप मुख्य रूप से किस बारे में जानकारी लेना चाहते हैं?
  
  • Hydroponics सीखना
  • Practical training
  • Farm setup करना
  • सिर्फ options explore करना`,

      Marathi: `आज आपण मुख्यतः कशाबद्दल माहिती घ्यायची आहे?

• Hydroponics सविस्तर शिकायचे आहे
• Practical hydroponic training ला सहभागी व्हायचे आहे
• Hydroponic farm setup करायचा आहे
• सध्या फक्त माहिती किंवा पर्याय पाहत आहात`,
    },

    email: {
      English: `I can send you details via email. Kindly share your email id ?`,

      Hindi: `मैं आपको पूरी जानकारी ईमेल के माध्यम से भेज सकता हूँ।
  कृपया अपना ईमेल आईडी साझा करें।`,
      Marathi: `मी आपल्याला सर्व माहिती ईमेलवर पाठवू शकतो.
कृपया आपला ईमेल आयडी सांगाल का, जेणेकरून मी आपल्याला सर्व details पाठवू शकेन.`,
    },

    mobileNumber: {
      English: `I can also send you details on WhatsApp. Is this number available on WhatsApp?`,

      Hindi: `मैं आपको सारी जानकारी WhatsApp पर भी भेज सकता हूँ।
क्या जिस नंबर पर मैंने कॉल किया है, वही नंबर WhatsApp पर उपलब्ध है??`,
      Marathi: `मी आपल्याला सर्व माहिती WhatsApp वर देखील पाठवू शकतो.
ज्या नंबरवर मी कॉल केला आहे, तोच नंबर WhatsApp वर उपलब्ध आहे का?`,
    },

    whatsappNumber: {
      English: `Do you have any alternative number, on which You want me to send whatsapp?`,

      Hindi: `क्या आपके पास कोई दूसरा नंबर है जिस पर आप चाहते हैं कि मैं WhatsApp पर जानकारी भेजूँ?`,
      Marathi: `आपल्याकडे दुसरा कोणता नंबर आहे का, ज्यावर मी WhatsApp वर माहिती पाठवू शकतो?`,
    },

    farm_construction_location: {
      English: `In which city or location are you planning to build the farm?`,

      Hindi: `कृपया बताइए, आप किस शहर या लोकेशन में farm बनाना चाहते हैं?`,
      Marathi: `कृपया सांगा, आपण कोणत्या शहरात किंवा लोकेशनवर farm उभारण्याचा विचार करत आहात?`,
    },

    farm_land_type: {
      English: `What type of land do you have — farm land, NA plot, terrace, or indoor space?`,

      Hindi: `आपके पास किस प्रकार की जगह उपलब्ध है — फार्म लैंड, NA प्लॉट, टेरेस या इनडोर स्पेस?`,
      Marathi: `आपल्याकडे कोणत्या प्रकारची जागा उपलब्ध आहे — शेती जमीन, NA प्लॉट, टेरेस की इनडोर स्पेस?`,
    },

    farm_construction_state: {
      English: `Can you also help me with name of state?`,

      Hindi: `क्या आप राज्य का नाम भी बता सकते हैं, जहाँ आप farm setup करने की योजना बना रहे हैं?`,
      Marathi: `आपण राज्याचे नावही सांगू शकता का, जिथे आपण farm setup करण्याचा विचार करत आहात?`,
    },

    total_area_available: {
      English: `What is the approximate area available?`,

      Hindi: `कृपया बताइए, आपके पास लगभग कितने क्षेत्रफल (area) की जगह उपलब्ध है?`,
      Marathi: `कृपया सांगा, आपल्याकडे अंदाजे किती क्षेत्रफळाची (area) जागा उपलब्ध आहे?`,
    },

    tentative_start_time: {
      English: `When are you planning to start the project — immediately, within 3 months, within 6 months, or later?`,
      Hindi: `आप इस प्रोजेक्ट को कब शुरू करने की योजना बना रहे हैं — तुरंत, 3 महीनों के अंदर, 6 महीनों के अंदर, या बाद में?`,
      Marathi: `आपण हा प्रोजेक्ट कधी सुरू करण्याचा विचार करत आहात — ताबडतोब, 3 महिन्यांच्या आत, 6 महिन्यांच्या आत, की नंतर?`,
    },

    looking_for_loan: {
      English: `Are you planning to take a bank loan for the project?`,

      Hindi: `क्या आप इस प्रोजेक्ट के लिए बैंक लोन लेने की योजना बना रहे हैं?`,
      Marathi: `आपण या प्रोजेक्टसाठी बँक लोन घेण्याचा विचार करत आहात का?`,
    },
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="col-12 ">
              <div className="card my-4">
                <div className="card-header">
                  <h3 className="page-title">
                    Please provide enquiry details below.
                  </h3>
                </div>
                <Formik
                  initialValues={enquiryInfoNew}
                  validationSchema={enquirySchema2}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <>
                      <div className="row">
                        <div className="col-12 col-md-3 col-lg-3 m-md-3 m-lg-3 m-0">
                          <div
                            className="card mx-2"
                            style={{
                              position: "sticky",
                              top: "100px",
                              maxHeight: "80vh",
                              overflowY: "auto",
                            }}
                          >
                            <div className="">
                              <div className=" text-center p-1">
                                <h2>CRM Script</h2>
                              </div>
                            </div>
                            <hr className="m-0 p-0"></hr>

                            <div className="card-body">
                              {props.values.preferredLanguage ? (
                                <>
                                  <p
                                    style={{
                                      whiteSpace: "pre-line",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {crmScripts[activeField]?.[
                                      props.values.preferredLanguage
                                    ] || "No script available for this field"}
                                  </p>
                                </>
                              ) : (
                                <p className="text-muted">
                                  Select language first to see CRM script
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-8 col-lg-8 m-md-3 m-lg-3 m-0 border">
                          <Form>
                            <div className="card-body">
                              {/* Mobile Number */}
                              {/* Preffered Language */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Preffered Language
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect
                                    type="text"
                                    name="preferredLanguage"
                                    onFocus={() =>
                                      setActiveField("preferredLanguage")
                                    }
                                  >
                                    <option value="">Select</option>
                                    <option value="English">English</option>
                                    <option value="Hindi">Hindi</option>
                                    <option value="Marathi">Marathi</option>
                                  </CustomSelect>

                                  {props.touched.preferredLanguage &&
                                    props.errors.preferredLanguage && (
                                      <p className="text-danger">
                                        {props.errors.preferredLanguage}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Phone number
                                </label>
                                <div className="w-100 col">
                                  <CustomInput
                                    name="mobileNumber"
                                    type="text"
                                    onBlur={(e) => {
                                      props.handleBlur(e);
                                      checkExistingEnquiry(
                                        e.target.value,
                                        props.values,
                                        props.setFieldValue
                                      );
                                    }}
                                    onFocus={() =>
                                      setActiveField("mobileNumber")
                                    }
                                  />
                                  {props.touched.mobileNumber &&
                                    props.errors.mobileNumber && (
                                      <p className="text-danger">
                                        {props.errors.mobileNumber}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label  col-3">
                                  Whatsapp number
                                </label>
                                <div className="w-100 col">
                                  <CustomInput
                                    name="whatsappNumber"
                                    type="text"
                                    // onBlur={(e) => {
                                    //   props.handleBlur(e);
                                    //   checkExistingEnquiry(
                                    //     e.target.value,
                                    //     props.setFieldValue
                                    //   );
                                    // }}
                                    onFocus={() =>
                                      setActiveField("whatsappNumber")
                                    }
                                  />
                                  {props.touched.whatsappNumber &&
                                    props.errors.whatsappNumber && (
                                      <p className="text-danger">
                                        {props.errors.whatsappNumber}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* First Name */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Full name
                                </label>
                                <div className="w-100 col">
                                  <CustomInput
                                    name="fullName"
                                    type="text"
                                    onFocus={() => setActiveField("fullName")}
                                  />
                                  {props.touched.fullName &&
                                    props.errors.fullName && (
                                      <p className="text-danger">
                                        {props.errors.fullName}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Email */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Email
                                </label>
                                <div className="w-100 col">
                                  <CustomInput
                                    name="email"
                                    type="email"
                                    onFocus={() => setActiveField("email")}
                                  />
                                  {props.touched.email &&
                                    props.errors.email && (
                                      <p className="text-danger">
                                        {props.errors.email}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Enquiry Origin */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Enquiry Origin
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect
                                    type="text"
                                    name="enquiryOrigin"
                                  >
                                    <option value="">Select Origin</option>
                                    <option value="MyOperator">
                                      My Operator
                                    </option>
                                    <option value="just_dial_enquiry">
                                      Just Dial
                                    </option>
                                    <option value="instagram">Instagram</option>
                                    <option value="Cheerio">Cheerio</option>
                                    <option value="webinar">Webinar</option>
                                    <option value="facebook">facebook</option>
                                    <option value="linkedin">Linkdin</option>
                                    <option value="indiaMart">indiaMart</option>
                                    <option value="Enquiry_from_alpha">
                                      Alpha Enquiry
                                    </option>
                                    <option value="Kryzen Website">
                                      Kryzen Website
                                    </option>
                                    <option value="emailEnquiry">
                                      Email Enquiry
                                    </option>
                                    <option value="subsidy">Subsidy</option>
                                    <option value="NHM-Alpha">NHM</option>
                                    <option value="NHB-Alpha">NHB</option>
                                    <option value="AIF-Alpha">AIF</option>
                                    <option value="Polyhouse-Construction-Alpha">
                                      PolyHouse Construction
                                    </option>
                                    <option value="exhibition">
                                      Exhibition
                                    </option>
                                    <option value="other">Other</option>
                                  </CustomSelect>

                                  {props.touched.enquiryOrigin &&
                                    props.errors.enquiryOrigin && (
                                      <p className="text-danger">
                                        {props.errors.enquiryOrigin}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Enquiry Related to */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Enquiry Related to
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect
                                    type="text"
                                    name="enquiryRelated"
                                    onFocus={() =>
                                      setActiveField("enquiryRelated")
                                    }
                                    onChange={(e) => {
                                      props.handleChange(e);

                                      if (e.target.value !== "Sales") {
                                        props.setFieldValue("interestedIn", []);
                                      }
                                    }}
                                  >
                                    <option value="">Select</option>
                                    <option value="Sales">Sales</option>
                                    <option value="Association">
                                      Association
                                    </option>
                                    <option value="Other Products">
                                      Other Products
                                    </option>
                                    <option value="Vendor">Vendor</option>
                                    <option value="Career">Career</option>
                                    <option value="Not Interested">
                                      Not Interested
                                    </option>
                                  </CustomSelect>

                                  {props.touched.enquiryRelated &&
                                    props.errors.enquiryRelated && (
                                      <p className="text-danger">
                                        {props.errors.enquiryRelated}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Interested in Products */}
                              {/* Interested in Products */}
                              {props?.values?.enquiryRelated === "Sales" && (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Interested In
                                  </label>

                                  <div className="w-100 col">
                                    {productOptions.map((product) => (
                                      <div
                                        className="form-check"
                                        key={product.value}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={product.value}
                                          value={product.value}
                                          onFocus={() =>
                                            setActiveField("interestedIn")
                                          }
                                          checked={(
                                            props.values.interestedIn || []
                                          ).includes(product.value)}
                                          onChange={(e) => {
                                            const checked = e.target.checked;

                                            let updated = [
                                              ...(props.values.interestedIn ||
                                                []),
                                            ];

                                            if (checked) {
                                              updated.push(product.value);
                                            } else {
                                              updated = updated.filter(
                                                (item) => item !== product.value
                                              );
                                            }

                                            props.setFieldValue(
                                              "interestedIn",
                                              updated
                                            );
                                          }}
                                        />

                                        <label
                                          className="form-check-label"
                                          htmlFor={product.value}
                                        >
                                          {product.label}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                  {props.touched.interestedIn &&
                                    props.errors.interestedIn && (
                                      <p className="text-danger">
                                        {props.errors.interestedIn}
                                      </p>
                                    )}
                                </div>
                              )}

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  What Would You Like to Know?
                                </label>
                                <div className="w-100 col">
                                  <CustomTextArea rows={4} name="notes" />
                                  {props.touched.notes &&
                                    props.errors.notes && (
                                      <p className="text-danger">
                                        {props.errors.notes}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            {/* Form Actions */}
                            <div className="card-footer">
                              <div className="btn-list justify-content-end">
                                <FormSubmitButton buttonText="Submit Enquiry" />
                                <SimpleButton
                                  buttonText="Cancel"
                                  type="secondary"
                                />
                              </div>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default CreateEnquiryForm;
